var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.46 13.807c0-.957-.086-1.877-.245-2.761H13.5v5.222h7.265a6.21 6.21 0 0 1-2.693 4.075v3.387h4.363c2.552-2.35 4.025-5.811 4.025-9.923z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.502 27c3.645 0 6.7-1.208 8.934-3.27l-4.363-3.387c-1.209.81-2.755 1.288-4.571 1.288-3.517 0-6.493-2.375-7.554-5.566h-4.51v3.498C3.658 23.975 8.223 27 13.502 27z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.946 16.065a8.115 8.115 0 0 1-.423-2.565c0-.89.153-1.755.423-2.565V7.437h-4.51A13.495 13.495 0 0 0 0 13.5c0 2.179.522 4.24 1.436 6.063l4.51-3.498z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.502 5.37c1.982 0 3.761.68 5.16 2.018l3.872-3.872C20.196 1.338 17.141 0 13.502 0 8.224 0 3.659 3.025 1.437 7.437l4.51 3.498c1.062-3.19 4.038-5.566 7.555-5.566z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleButtonIcon);
export default __webpack_public_path__ + "static/media/google-button-icon.88dd9a43c179ae4701b28dbe2b7473ba.svg";
export { ForwardRef as ReactComponent };